import axios from "axios";
import moment from "moment";

const dependentesStore = {
  namespaced: true,
  state: {
    dependentes: [],
    ID: 0,
    modalAjuda: false,
    ajudaSelecionada: null,
    step: 1,
    dependenteEnviar: {
      nome: "",
      dtNascimento: "",
      depImpostoRenda: false,
      observacao: "",
      inativarDepend: false,
    },
    dependenteSelec: null,
  },
  mutations: {
    setDependentes(state, deps) {
      state.dependentes = deps;
    },
    setModalAjuda(state, modal) {
      state.modalAjuda = modal;
    },
    setAjudaSelecionada(state, ajuda) {
      state.ajudaSelecionada = ajuda;
    },
    setNextStep(state) {
      state.step++;
    },
    setBackStep(state) {
      state.step--;
    },
    setStep(state, step) {
      state.step = step;
    },
    setDependente(state, dep) {
      state.dependenteSelec = dep;
    },
  },
  actions: {
    async getDependentes(context, data) {
      context.commit("setDependentes", []);
      await axios
        .get(`/colaborador/dependentes?funcao=dependentes&usar=${data ?? ''}`)
        .then((res) => {
          if (res.data.success) {
            context.commit("setDependentes", res.data.data);
          }
        });
    },
  },
  getters: {
    getConfigDocs(state, context, data) {
      if (data.atestado.configs.length > 0) {
        var idade = moment().diff(
          moment(state.dependenteEnviar.dtNascimento),
          "years"
        );

        var docsRet = data.atestado.configs
          .find((config) => config.cadastdependente)
          .anexos.filter(
            (doc) =>
              doc.codsituacao == 0 ||
              (doc.codsituacao > 0 &&
                idade >= doc.idadeinicial &&
                idade <= doc.idadefinal)
          );

        if (state.dependenteSelec) {
          docsRet = docsRet.filter(
            (doc) => doc.alterar && !state.dependenteEnviar.inativarDepend
          );
        } else {
          docsRet = docsRet.filter((doc) => doc.incluir);
        }

        return docsRet;
      }
      return [];
    },
  },
};

export default dependentesStore;
